<template>
  <div>
    <p class="title_sp">
      <custom-breadcrumb />
    </p>
    <p style="margin-top: 50px;">
      <span> Business name</span>
      <el-input placeholder="Please enter business name" v-model="businessName" :disabled="true"></el-input>
    </p>
    <p>
       <span>Country </span>
      <el-input placeholder="Please enter country" v-model="country"></el-input>
    </p>
    <p>
      <span>Business Address</span>
      <el-input placeholder="Please enter business address" v-model="businessAddress"></el-input>
    </p>
    <p>
      <span>Tax ID</span>
      <el-input placeholder="Please enter tax ID" v-model="taxId"></el-input>
    </p>
    <p>
      <span>Contract</span>
      <span v-if="contract" class="contract" @click="downloadFile()">Contract.pdf</span>
      <span v-else>No contract</span>
    </p>
    <p>
      <span>Annual Revenue(USD)</span>
      <el-input placeholder="Please enter annual revenue" v-model="annualIncome"></el-input>
    </p>

    <p>
      <el-button type="info" disabled>save</el-button>
    </p>
  </div>
</template>

<script>
import {getAction, downloadStaticFile} from '@/api/manage.js'
import CustomBreadcrumb from '../components/custom-breadcrumb'
export default {
  components: {CustomBreadcrumb},
  data() {
    return {
      businessName: '',
      country: '',
      businessAddress: '',
      taxId: '',
      contract: '',
      annualIncome: ''
    }
  },
  created() {
    this.getBusiness()
  },
  methods: {
    getBusiness() {
      getAction('/sp/suppliers/business').then((response) => {
        if (response.success) {
          if (response.result) {
            this.businessName = response.result.name
            this.country = response.result.countryCode
            this.businessAddress = response.result.address
            this.taxId = response.result.taxId
            this.contract = response.result.contract
            this.annualIncome = response.result.annualIncome
          }
        } else {
          this.$message.warning(response.success)
        }
      })
    },
    downloadFile() {
      downloadStaticFile(this.contract)
    }

  }

}
</script>

<style lang="less" scoped>
p,span{display: block; margin-bottom: 10px;}
.contract{color: #0B8CF4;text-decoration: underline;cursor: pointer;}
.title_sp{
  font-size: 14px;
  font-family: Graphik;
  font-weight: 600;
  color: #262B2F;
  margin: 10px 30px 20px 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/update-business.vue